<template>
    <tailwind-layout :title="'For Rent: '+property.full_address">
        <PropertyListing :property="property" :inactive="application_inactive" :maps-embed-key="maps_embed_key">
            <template #cta>
                <ApplicationsClosedButton v-if="application_inactive && !existingApplication" :label="applyLabel" />
                <ApplicationsClosedButton
                    v-else-if="isAgent"
                    :label="applyLabel"
                    message="Agents and landlords can't apply to properties."
                    note="You cannot apply to this property because you are an agent or landlord. A Register and Login button will be displayed if the visitor does not have a RentRisk account. If the visitor does have a RentRisk account a Begin or Resume Application button will appear."
                />
                <template v-else>
                    <div v-if="showEsoToggle" class="mb-4 rounded-lg border border-blue-200 bg-blue-50 p-4">
                        <label class="flex cursor-pointer items-start gap-3">
                            <input v-model="esoOptIn" type="checkbox" class="mt-1 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                            <span class="text-sm text-gray-700">
                                In a competitive rental market? Stand out from competing applicants by verifying identity, income, employment and assets for an additional ${{ eso_price }}.
                                <br /><span class="text-xs italic text-gray-500">Hint: Applicants who verify these items signal transparency, financial stability and serious intent.</span>
                            </span>
                        </label>
                    </div>
                    <form @submit.prevent="store">
                        <button
                            type="submit"
                            class="flex w-full items-center justify-center gap-2 rounded-lg bg-gray-900 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-gray-800 disabled:opacity-50"
                            :disabled="form.processing"
                            data-test="apply-button"
                        >
                            <font-awesome-icon :icon="faCircleArrowRight" class="h-4 w-4" aria-hidden="true" />
                            {{ applyLabel }}
                        </button>
                    </form>
                </template>
            </template>
        </PropertyListing>
    </tailwind-layout>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleArrowRight } from '@fortawesome/pro-light-svg-icons'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import ApplicationsClosedButton from './Partials/ApplicationsClosedButton.vue'
import PropertyListing from './Partials/PropertyListing.vue'

export default {
    components: {
        ApplicationsClosedButton,
        FontAwesomeIcon,
        PropertyListing,
        TailwindLayout,
    },
    props: {
        property: Object,
        existingApplication: Object,
        is_main_applicant : Boolean,
        property_id : String,
        eso_price: {
            type: Number,
            default: 29,
        },
        application_inactive: {
            type: Boolean,
            default: false,
        },
        maps_embed_key: {
            type: String,
            default: '',
        },
        is_archived: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            esoOptIn: false,
            faCircleArrowRight,
            form: this.$inertia.form({
                status: '',
                step: '',
                property_id: this.property_id,
                eso_optin: false,
            }),
        }
    },
    computed: {
        applyLabel() {
            return this.existingApplication ? 'Resume Application' : 'Begin Application'
        },
        isAgent() {
            return this.$page.props.user?.role === 'agent'
        },
        showEsoToggle() {
            const automatic =
                this.property.effective_auto_eso_active === true ||
                (this.property.effective_auto_eso_active === undefined && this.property.auto_eso_enabled);
            return !automatic && !this.property.is_agent_fee && !this.existingApplication;
        },
    },
    watch: {
        esoOptIn(val) {
            this.form.eso_optin = val;
        },
    },
    methods: {
        store() {
            this.form.post(this.route('applications.store'))
        },
    },
}
</script>
